import { Box } from "@mui/material";
import { OutputTableCellSelectNew } from "../components/OutputTableCellSelect";
import { analyts_list } from "./analyst_list";
import axiosInstance from "../../../http-common";
import { useEffect, useState } from "react";

export const Render_output_remarks_cell = (props) => {
  // console.log(props);
  const { colDef, row, api, value, id, } = props;
  const { field, editable } = colDef;
  const status = row[field];
  // console.log(props);
  const [select_options, set_selected_options] = useState([
    { value: "Pending", label: "Pending" },
    { value: "Completed", label: "Completed" },
    { value: "Under Test", label: "Under Test" },
    { value: "OOS", label: "OOS" },
    { value: "OOT", label: "OOT" },
    { value: "Deviation", label: "Deviation" },
    { value: "Lab Event", label: "Lab Event" },
    // { value: "QMS Impacted sample", label: "QMS Impacted sample" },
  ]);

  useEffect(() => {
    if (
      status === "OOS" ||
      status === "OOT" ||
      status === "Deviation" ||
      value === "Approved for Rescheduling"
    ) {
      set_selected_options((prev) => {
        const temp = [...prev];
        temp.push({
          value: "Approved for Rescheduling",
          label: "Approved for Rescheduling",
        });
        // console.log(temp);
        return Array.from(new Set(temp));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  // useEffect(() => {
  //   console.log({ select_options, status });
  // }, [select_options]);

  if (status === "N") {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]],
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <p className="text-sm p-2">Not Required</p>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          // height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]]
        }}
      >
        <OutputTableCellSelectNew
          excel_row={row}
          key_name={field}
          disabled={!editable}
          select_options={
            // [
            //   ...select_options.remark_status
            // ]
            select_options
          }
          select_status={row[field] || "Pending"}
          change_handler={(value, set_for_parent) => {
            console.log("value", value);
            if (["OOS", "OOT", "Lab Event", "Deviation"].includes(value)) {
              // console.log("ok");
              api.selectedRow = row;
              api.set_selected_row({
                ...row,
                previousValue: row[field],
                newValue: value,
              });
              const cancel_update = () => {
                console.log("cancelled :/");
                api.set_selected_row({});
                api.updateRows([{ id: row.id, [field]: row[field] }]);
                set_for_parent(row[field]);
              };
              api.cancel_update = cancel_update;
              const confirm_update = ({
                remarks,
                equipment_id,
                time,
                category,
              }) => {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                const material_type = row.sample_type;
                let raw = JSON.stringify({});
                if (value === "Lab Event") {
                  raw = JSON.stringify({
                    _id: row._id,
                    status: value,
                    material_type,
                    remarks,
                    equipment_id,
                    time,
                    category,
                  });
                } else {
                  raw = JSON.stringify({
                    _id: row._id,
                    status: value,
                    material_type,
                    remarks,
                  });
                }
                axiosInstance
                  .post(
                    `v1/qc/update_schedule_status/?schedule_type=${row?.approve ? "approved" : "adhoc"
                    }`,
                    raw,
                    {
                      headers: myHeaders,
                    }
                  )
                  .then((response) => response.data)
                  .then((result) => console.log(result))
                  .catch((error) => console.log("error", error));
                set_for_parent(value);
                api.updateRows([
                  { id: row.id, [field]: value, remark: remarks },
                ]);
                console.log(row);
              };
              api.confirm_update = confirm_update;
            } else {
              // to update value on fe only
              api.updateRows([{ id, [field]: value }]);

              var myHeaders = new Headers();
              myHeaders.append("Content-Type", "application/json");
              const material_type = row.sample_type;
              var raw = JSON.stringify({
                // "batch_number": row.batch_no,
                // "field_to_update": row.test_name,
                // "value": status
                _id: row._id,
                status: value,
                material_type,
              });
              axiosInstance
                .post(
                  `v1/qc/update_schedule_status/?schedule_type=${row?.approve ? "approved" : "adhoc"
                  }`,
                  raw,
                  {
                    headers: myHeaders,
                  }
                )
                .then((response) => response.data)
                .then((result) => console.log(result))
                .catch((error) => console.log("error", error));
            }
          }}
        />
      </Box>
    );
  }
};

export const render_select_analyst_cell = (
  props,
  update_analyst,
  todays_schedule
) => {
  const { colDef, row } = props;
  const { field } = colDef;

  return (
    <Box
      sx={{
        width: "100%",
        // height: "100%",
        // padding: "10px",
        // margin: "10px",
        // backgroundColor: status_to_background_color_mapping[row[field]]
      }}
    >
      <OutputTableCellSelectNew
        excel_row={row}
        key_name={field}
        select_options={[...analyts_list]}
        select_status={row[field] || "Ajay Mittal"}
        change_handler={(value) => {
          // console.log({ props });
          update_analyst(props.row, value, todays_schedule);
        }}
      />
    </Box>
  );
};
